import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { getUserRequestInfo } from '../actions/user-session'

import Loading from '../components/common/loading'
import Register from './register'

class Join extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  componentWillMount() {
    const { joinCode } = this.props.match.params
    const { userSession } = this.props

    if (joinCode && !userSession.registrationRequest && !userSession.registration) this.props.getUserRequestInfo(joinCode)
    if (userSession.loggedIn) this.props.removeUserSession
  }

  componentWillReceiveProps(nextProps) {
    const { userSession } = nextProps

    if (userSession.verification && userSession.verification.required) this.props.history.replace({pathname: `/register`})
  }

  render() {
    const { userSession } = this.props

    return (
      <div className="join">
        {
          userSession && userSession.registration
          ? <div>
              <h1>You have joined event</h1>
              <Link to="/login">Log in →</Link>
            </div>
          : userSession && userSession.registrationRequest
            ? <div>
                <h1>Join event</h1>
                <Register email={userSession.registrationRequest.email} requestCode={userSession.registrationRequest.code} />
              </div>
            : userSession.error
              ? <div>
                  <h1>{userSession.error.message}</h1>
                </div>
              : <div>
                  <h1>Looking up the event</h1>
                  <Loading />
                </div>
        }
      </div>
    )
  }
}

Join.propTypes = {
  userSession: PropTypes.object,
  getUserRequestInfo: PropTypes.func
}

Join.defaultProps = {
  userSession: {},
  getUserRequestInfo: function() {}
}

export const mapStateToProps = (state) => {
  return {
    userSession: state.userSession
  }
}

export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getUserRequestInfo
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Join)



// WEBPACK FOOTER //
// ./src/containers/join.js